
import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import Tokenization from "../../components/admin/Tokenization";

const AdminTokenization: React.FC = () => {
  return (
    <MainLayout>
      <Tokenization />
    </MainLayout>
  );
};

export default AdminTokenization;
